export default "__VITE_ASSET__063d5712__"